module.exports = __webpack_public_path__ + "img/prefix_suffix_white.e3e0a09f.svg";